import React from "react";

const Footer = () => (
  <footer className="py-8 bg-gray-800 text-white text-center">
    <p className="mb-2">&copy; {new Date().getFullYear()} Query Minds. All rights reserved.</p>
    <div className="flex justify-center space-x-4">
      <button
        onClick={() => alert("Privacy Policy coming soon!")}
        className="hover:underline"
        aria-label="Privacy Policy"
      >
        Privacy Policy
      </button>
      <button
        onClick={() => alert("Terms of Service coming soon!")}
        className="hover:underline"
        aria-label="Terms of Service"
      >
        Terms of Service
      </button>
    </div>
  </footer>
);

export default Footer;
